<script setup lang="ts">
import { PhSignOut } from "@phosphor-icons/vue";
</script>

<template>
  <dialog id="logoutDialog" class="logout-dialog" aria-labelledby="logoutDialogTitle" aria-describedby="logoutDialogDescription">
    <span class="logout-dialog-icon" aria-hidden="true">
      <PhSignOut :size="20" weight="bold" />
    </span>
    <h2 id="logoutDialogTitle">退出登录？</h2>
    <p id="logoutDialogDescription">这台设备需要重新验证邮箱才能登录。</p>
    <p id="logoutDialogError" class="auth-message" data-tone="error" role="alert" hidden></p>
    <div class="logout-dialog-actions">
      <button id="logoutCancelButton" class="secondary-button" type="button">取消</button>
      <button id="logoutConfirmButton" class="danger-button" type="button">
        <span class="button-progress" aria-hidden="true"></span>
        <PhSignOut class="logout-confirm-icon" :size="16" weight="bold" aria-hidden="true" />
        <span>退出登录</span>
      </button>
    </div>
  </dialog>
</template>
